import { useQuery } from 'react-query';

import { Advertisement } from '../../../types/Advertisement';
import { PaginatedList } from '../../../types/PaginatedList';
import Api from '../../api/api';

export const getAdvertisementsByPage = async (
  page: number,
  sort: string,
  search?: string,
  published?: boolean,
): Promise<PaginatedList<Advertisement>> => {
  const [response, bodyOrError] = await Api.get(`advertisement`, {
    page,
    sort,
    search,
    ...(published ? { published: true } : {}),
  });

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetAdvertisementsByPage = ({
  page,
  sort,
  search = '',
  published,
}: {
  page: number;
  sort: string;
  search?: string;
  published?: boolean;
}) =>
  useQuery(['getAdvertisementsByPage', page, sort, search, published], () => getAdvertisementsByPage(page, sort, search, published), {
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
